(function () {
  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    // Get API URL from data attribute (configured at top of file)
    const container = document.querySelector(
      ".custom-shipping-rate-machship_container"
    );

    if (!container) {
      console.warn("⚠️ Shipping calculator container not found");
      return;
    }

    const API_URL = container.getAttribute("data-api-url");
    const PRODUCT_ID = container.getAttribute("data-product-id");

    // Log for debugging
    console.log("🚀 Shipping Calculator Initialized");
    console.log("📡 API URL:", API_URL);
    console.log("📦 Product ID:", PRODUCT_ID);

    // Get current variant ID
    function getCurrentVariantId() {
      const variantSelect = document.querySelector('select[name="id"]');
      const variantInput = document.querySelector('input[name="id"]');
      const variantIdFromUrl = new URLSearchParams(window.location.search).get(
        "variant"
      );

      if (variantSelect && variantSelect.value) {
        return variantSelect.value;
      }
      if (variantInput && variantInput.value) {
        return variantInput.value;
      }
      if (variantIdFromUrl) {
        return variantIdFromUrl;
      }

      // Fallback: get from data attribute set in Liquid template
      const fallbackVariantId = container.getAttribute("data-variant-id");
      return fallbackVariantId || null;
    }

    // Get message element from Liquid template
    function getMessageElement() {
      const messageElement = container.getAttribute("shipping-message");
      return messageElement || "Estimated freight charges from our NSW distribution centre (unloading not included). Actual rates are subject to confirmation by our sales specialist team.";
    }

    // Display results
    function displayResults(data) {
      const resultsContainer = document.getElementById("shipping-results");

      if (
        !data.success ||
        !data.rates ||
        !data.rates.rates ||
        data.rates.rates.length === 0
      ) {
        resultsContainer.innerHTML =
          '<p style="color: #666; text-align: center; padding: 1rem;">No shipping rates available for this destination.</p>';
        return;
      }

      const rates = data.rates.rates;
      const machshipRaw = data.rates.machshipRaw || [];

      let html = '<div class="shipping-rates-list">';

      rates.forEach((rate, index) => {
        const rawRate = machshipRaw[index] || {};

        html += `
        <div class="rate-option">
          <div class="rate-header">
            <div class="rate-price">
              Estimated: <span class="price">$${rate.totalCost.toFixed(2)}</span>
            </div>
            <div class="carrier-info">
              <strong>${rate.carrierName}</strong>
            </div>
          </div>
        </div>
      `;
      });

      html += "</div>";

      if (data.applied_markup) {
        html += `<div class="markup-note">
          ${getMessageElement()}
        </div>`;
      }

      resultsContainer.innerHTML = html;
    }

    // Display error
    function displayError(message, suggestion) {
      const errorDiv = document.getElementById("shipping-error");
      const errorText = errorDiv.querySelector("p");

      if (suggestion) {
        errorText.innerHTML = `<strong>⚠️ ${message}</strong><br><small>💡 Suggestion: ${suggestion}</small>`;
      } else {
        errorText.textContent = message;
      }

      errorDiv.style.display = "block";

      setTimeout(() => {
        errorDiv.style.display = "none";
      }, 8000);
    }

    // Calculate shipping
    async function calculateShipping() {
      const postcodeInput = document.getElementById("shipping-postcode");
      const suburbInput = document.getElementById("shipping-suburb");
      const button = document.getElementById("calculate-shipping");
      const buttonText = button.querySelector(".button-text");
      const buttonLoading = button.querySelector(".button-loading");
      const resultsContainer = document.getElementById("shipping-results");
      const errorDiv = document.getElementById("shipping-error");

      // Validation
      if (!suburbInput.value || suburbInput.value.trim().length < 2) {
        displayError("Please enter a suburb");
        suburbInput.focus();
        return;
      }

      if (!postcodeInput.value || postcodeInput.value.length < 3) {
        displayError("Please enter a valid postcode");
        postcodeInput.focus();
        return;
      }

      // Show loading state
      buttonText.style.display = "none";
      buttonLoading.style.display = "inline";
      button.disabled = true;
      resultsContainer.innerHTML =
        '<p style="text-align: left; padding: 0.2rem 0.2rem;">Calculating shipping rates...</p>';
      errorDiv.style.display = "none";

      try {
        const variantId = getCurrentVariantId();

        // Clean suburb input (capitalize first letter of each word)
        const cleanSuburb = suburbInput.value
          .trim()
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");

        console.log("📤 Sending request:", {
          productId: PRODUCT_ID,
          variantId: variantId,
          destination: {
            suburb: cleanSuburb,
            postcode: postcodeInput.value,
          },
        });

        // Make API request
        const response = await fetch(
          `${API_URL}/api/shipping/product/${PRODUCT_ID}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              destination: {
                suburb: cleanSuburb,
                postcode: postcodeInput.value,
              },
              variant_id: variantId,
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log("📥 Response received:", data);

        // Check for validation errors
        if (!data.success && data.errorType === "INVALID_POSTCODE") {
          displayError(data.error, data.suggestion);
          resultsContainer.innerHTML = `
          <div style="padding: 1rem; background: #fff3cd; border-radius: 4px; border: 1px solid #ffc107;">
            <p style="margin: 0; color: #856404;">
              <strong>Invalid Postcode</strong><br>
              ${data.error}
            </p>
            ${
              data.suggestion
                ? `<p style="margin: 0.5rem 0 0 0; font-size: 0.9em; color: #856404;">
              💡 ${data.suggestion}
            </p>`
                : ""
            }
          </div>
        `;
          return;
        }

        displayResults(data);
      } catch (error) {
        console.error("❌ Error calculating shipping:", error);
        displayError(
        );
        resultsContainer.innerHTML =
          '<p style="color: #666; padding: 1rem 0; margin: 0 !important;">No shipping rates were found for the entered location. Please verify that the suburb and postcode are correct, or contact our sales specialist team to confirm available delivery options.</p>';
      } finally {
        // Reset button state
        buttonText.style.display = "inline";
        buttonLoading.style.display = "none";
        button.disabled = false;
      }
    }

    // Set up event listeners
    const calculateButton = document.getElementById("calculate-shipping");
    const postcodeInput = document.getElementById("shipping-postcode");
    const suburbInput = document.getElementById("shipping-suburb");

    if (calculateButton) {
      calculateButton.addEventListener("click", calculateShipping);
    }

    // Calculate on Enter key in any input
    [postcodeInput, suburbInput].forEach((input) => {
      if (input) {
        input.addEventListener("keypress", function (e) {
          if (e.key === "Enter") {
            e.preventDefault();
            calculateShipping();
          }
        });
      }
    });

    // Listen for variant changes
    const variantSelector = document.querySelector(
      'select[name="id"], input[name="id"]'
    );
    if (variantSelector) {
      variantSelector.addEventListener("change", function () {
        const resultsContainer = document.getElementById("shipping-results");
        resultsContainer.innerHTML =
          '<p style="color: #666; text-align: center; padding: 1rem;">Enter your location to see shipping options for this variant</p>';
      });
    }
  } // End init function
})();
